module.exports = __webpack_public_path__ + "img/meat_chuckroll.fc3dbbb0.jpg";